// Image Gallery Functionality
document.addEventListener('DOMContentLoaded', function() {
    const mobileThumbnails = document.querySelectorAll('.mobile-thumbnail-image');
    const desktopThumbnails = document.querySelectorAll('.thumbnail-image');
    const mainImage = document.querySelector('.main-product-image');

    // Function to update main image
    function updateMainImage(fullImageSrc) {
        if (mainImage) {
            mainImage.src = fullImageSrc;
        }
    }

    // Function to update selected state
    function updateSelectedState(clickedThumbnail) {
        // Remove selected class from all thumbnails
        mobileThumbnails.forEach(thumb => thumb.classList.remove('selected'));
        desktopThumbnails.forEach(thumb => thumb.classList.remove('selected'));
        
        // Add selected class to clicked thumbnail
        clickedThumbnail.classList.add('selected');
    }

    // Add click event listeners to mobile thumbnails
    mobileThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            const fullImageSrc = this.getAttribute('data-full-image');
            if (fullImageSrc) {
                updateMainImage(fullImageSrc);
                updateSelectedState(this);
            }
        });
    });

    // Add click event listeners to desktop thumbnails
    desktopThumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function() {
            const fullImageSrc = this.getAttribute('data-full-image');
            if (fullImageSrc) {
                updateMainImage(fullImageSrc);
                updateSelectedState(this);
            }
        });
    });

    // Set first thumbnail as selected by default
    if (mobileThumbnails.length > 0) {
        mobileThumbnails[0].classList.add('selected');
    }
    if (desktopThumbnails.length > 0) {
        desktopThumbnails[0].classList.add('selected');
    }
});

// Product Tabs Functionality
document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.product-tabs .tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');
    
    // Enhanced tab functionality to handle Vitals integration
    function showTab(targetTabId) {
        // Remove active class from all buttons and content
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        
        // Add active class to target tab content
        const targetTab = document.getElementById(targetTabId);
        if (targetTab) {
            targetTab.classList.add('active');
        }
    }
    
    // Handle tab button clicks
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            // Remove active class from all buttons
            tabButtons.forEach(btn => btn.classList.remove('active'));
            
            // Add active class to clicked button
            this.classList.add('active');
            
            // Show corresponding tab content
            const tabId = this.textContent.trim().toLowerCase().replace(/\s+/g, '-');
            let targetId = '';
            
            switch(tabId) {
                case 'description':
                    targetId = 'product-info-tab';
                    break;
                case 'technical-info':
                    targetId = 'technical-info-tab';
                    break;
                case 'delivery':
                    targetId = 'delivery-tab';
                    break;
                case 'returns':
                    targetId = 'returns-tab';
                    break;
            }
            
            if (targetId) {
                showTab(targetId);
            }
        });
    });
    
    // Ensure initial state is correct
    showTab('product-info-tab');
});
